module.exports = __webpack_public_path__ + "static/media/muted-mic-icon-white.1d2f9b2f.svg";